export const PHOTO_EDITOR_CONFIG = {
	autoTrim: {
		maxAnalysisEdge: 2048,
		alphaEmpty: 14,
		nearWhite: 250,
		minOpaqueAlpha: 248,
		edgePadding: 2
	},
	output: {
		jpegQuality: 0.92,
		maxExportEdgePx: 4096
	},
	layout: {
		canvasReadyMaxAttempts: 40,
		minCropRectPx: 4,
		minContentDimPx: 2,
		imageEdgePaddingPx: 24
	},
	trim: {
		containScaleMin: 0.08,
		containScaleMax: 12
	}
} as const;

export const PHOTO_EDITOR_CROPPER_TEMPLATE: string =
	'<cropper-canvas background action="move">' +
	'<cropper-image action="move" rotatable scalable skewable translatable></cropper-image>' +
	'<cropper-shade></cropper-shade>' +
	'<cropper-selection initial-coverage="0.5" movable resizable>' +
	'<cropper-grid role="grid" bordered covered></cropper-grid>' +
	'<cropper-crosshair centered></cropper-crosshair>' +
	'<cropper-handle action="move" theme-color="rgba(255, 255, 255, 0.35)"></cropper-handle>' +
	'<cropper-handle action="n-resize"></cropper-handle>' +
	'<cropper-handle action="e-resize"></cropper-handle>' +
	'<cropper-handle action="s-resize"></cropper-handle>' +
	'<cropper-handle action="w-resize"></cropper-handle>' +
	'<cropper-handle action="ne-resize"></cropper-handle>' +
	'<cropper-handle action="nw-resize"></cropper-handle>' +
	'<cropper-handle action="se-resize"></cropper-handle>' +
	'<cropper-handle action="sw-resize"></cropper-handle>' +
	'</cropper-selection>' +
	'</cropper-canvas>';

export type PhotoEditorConfig = typeof PHOTO_EDITOR_CONFIG;

export type PhotoEditorConfigInput = Partial<{
	autoTrim: Partial<PhotoEditorConfig['autoTrim']>;
	output: Partial<PhotoEditorConfig['output']>;
	layout: Partial<PhotoEditorConfig['layout']>;
	trim: Partial<PhotoEditorConfig['trim']>;
}>;

export function mergePhotoEditorConfig(base: PhotoEditorConfig, override?: PhotoEditorConfigInput): PhotoEditorConfig {
	if (!override) return base;
	return {
		...base,
		autoTrim: { ...base.autoTrim, ...override.autoTrim },
		output: { ...base.output, ...override.output },
		layout: { ...base.layout, ...override.layout },
		trim: { ...base.trim, ...override.trim }
	};
}
